import { Window } from "@progress/kendo-react-dialogs";
import { GuestEventForm } from "./GuestEventForm";

function GuestEventUpdate(props) {
  return (
    <Window
      title={props.title}
      onClose={props.toggleDialog}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"40vh"}
      initialWidth={"35%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      <GuestEventForm
        toggleDialog={props.toggleDialog}
        isAdded={props.isAdded}
        setIsAdded={props.setIsAdded}
        event={props.event}
        isUpdate={true}
      />
    </Window>
  );
}

export { GuestEventUpdate };
